export const DEFAULT_REDIRECT_PATH = '/';
export const LOGIN_PATH = '/user/login';
export const FEISHU_CALLBACK_PATH = '/user/login/feishu/callback';
export const AUTH_PATHS = [LOGIN_PATH, FEISHU_CALLBACK_PATH];

export const DEFAULT_FEISHU_REDIRECT_PATH = FEISHU_CALLBACK_PATH;
export const DEFAULT_FEISHU_AUTHORIZE_URL =
  'https://passport.feishu.cn/suite/passport/oauth/authorize';
export const DEFAULT_FEISHU_QR_SDK_URL =
  'https://lf-package-cn.feishucdn.com/obj/feishu-static/lark/passport/qrcode/LarkSSOSDKWebQRCode-1.0.3.js';
